import { createEmptyEdl, getEdlDuration } from "./projectSchema";
import { hydrateEdlClipDefaults } from "./clipProperties";
import { reflowAllOverlayLanes } from "./clipTimelineUtils";

export const firebaseListToArray = (value) => {
  if (Array.isArray(value)) {
    return value.filter((item) => item != null);
  }

  if (!value || typeof value !== "object") {
    return [];
  }

  return Object.keys(value)
    .sort((left, right) => Number(left) - Number(right))
    .map((key) => value[key])
    .filter((item) => item != null);
};

export const serializeEdlForFirebase = ({ edl }) => {
  if (!edl) {
    return null;
  }

  try {
    return JSON.parse(JSON.stringify(edl));
  } catch {
    return null;
  }
};

export const hydratePersistedEdl = ({
  snapshot,
  sourceAssetID = "",
  sourceName = "",
}) => {
  const persistedEdl = snapshot?.edl;
  const clipsById = persistedEdl?.clips?.byId;
  const tracksById = persistedEdl?.tracks?.byId;
  if (!clipsById || !tracksById || Object.keys(clipsById).length === 0) {
    return null;
  }

  const nextTracksById = {};
  Object.entries(tracksById).forEach(([trackId, track]) => {
    nextTracksById[trackId] = {
      ...track,
      id: track?.id || trackId,
      clipIds: firebaseListToArray(track?.clipIds),
    };
  });

  const trackOrder = firebaseListToArray(persistedEdl.tracks?.order);
  const nextEdl = {
    ...createEmptyEdl(),
    ...persistedEdl,
    sourceAssetID: sourceAssetID || persistedEdl.sourceAssetID || "",
    sourceName: sourceName || persistedEdl.sourceName || "",
    tracks: {
      byId: nextTracksById,
      order: trackOrder.length ? trackOrder : Object.keys(nextTracksById),
    },
    clips: {
      byId: clipsById,
    },
    effects: firebaseListToArray(persistedEdl.effects),
    transitions: firebaseListToArray(persistedEdl.transitions),
    cues: firebaseListToArray(persistedEdl.cues),
    playhead: Math.max(0, Number(persistedEdl.playhead) || 0),
  };

  return normalizeVideoEditorEdl({ edl: nextEdl });
};

export const normalizeVideoEditorEdl = ({ edl }) => {
  if (!edl) {
    return edl;
  }

  const hydrated = hydrateEdlClipDefaults({ edl });
  const packed = reflowAllOverlayLanes({ edl: hydrated });

  return {
    ...packed,
    duration: getEdlDuration({ edl: packed }),
  };
};
